import config from '@config'
import script from '@lib/script'

export const collectMercadoPagoDeviceId = async () => {
  try {
    await script.load(config.mercadopago.securityScript.url, tag => {
      tag.setAttribute('view', 'checkout')
    })
  } catch {}
}

export default collectMercadoPagoDeviceId
